export default class CommentForm {
  constructor(selector) {
    this.initiators = document.querySelectorAll(selector);
    if (!this.initiators) {
      return;
    }

    this.getFormElements()?.forEach((form) => {
      const submitButton = this.getSubmitButton(form);
      const fileInput = this.getFileInput(form);
      const textarea = this.getTextarea(form);

      if ([submitButton, fileInput, textarea].some((element) => element === null)) {
        return;
      }

      form.addEventListener('submit', () => {
        const attachmentItems = this.setAttachmentItems(form);
        const attachmentDeleteButtons = this.setAttachmentDeleteButtons(attachmentItems);

        textarea.readOnly = true;

        [
          submitButton,
          fileInput,
          ...attachmentDeleteButtons.map((button) => button)
        ].forEach((element) => element.addEventListener('click', this.disableClick));
      });
    });
  }

  getFormElements() {
    return [...this.initiators].map((element) => element.querySelector('form'));
  }

  getSubmitButton(form) {
    return form?.querySelector('[type=submit]');
  }

  getFileInput(form) {
    return form?.querySelector('[type=file]');
  }

  getTextarea(form) {
    return form?.querySelector('textarea');
  }

  setAttachmentContainers(form) {
    return [...form.querySelectorAll('[data-attachment-item-list]')];
  }

  setAttachmentItems(form) {
    return [...form.querySelectorAll('[data-attachment-name]')];
  }

  setAttachmentDeleteButtons(attachmentItems) {
    return attachmentItems?.length
      ? attachmentItems.map((item) => item.querySelector('[type=button]'))
      : [];
  }

  disableClick(e) {
    e.preventDefault();
  }

  releaseDisable() {
    this.getFormElements()?.forEach((form) => {
      const textarea = this.getTextarea(form);
      textarea.readOnly = false;

      [
        this.getSubmitButton(form),
        this.getFileInput(form),
      ].forEach((element) => element.removeEventListener('click', this.disableClick));
    });
  }

  resetForm() {
    this.getFormElements()?.forEach((form) => {
      const textarea = this.getTextarea(form);
      const fileInput = this.getFileInput(form);
      const attachmentItems = this.setAttachmentItems(form);
      const attachmentContainers = this.setAttachmentContainers(form);

      textarea.value = '';
      fileInput.value = '';
      textarea.dispatchEvent(new Event('change'));
      fileInput.dispatchEvent(new Event('change'));

      attachmentItems.forEach((item) => {
        item.remove();
      });

      attachmentContainers.forEach((container) => {
        container.ariaHidden = true;
      });
    });

    return this;
  }
}

export {
  CommentForm
};
